import { Button } from "@/components/ui/button";
export const LetsConnect = () => {
  return <section className="py-12 md:py-0">
      <div className="max-w-[840px]">
        <h2 className="text-[40px] md:text-[62px] leading-[1] font-medium">
          Let's get on a quick call
        </h2>
        <p className="mt-8 text-[22px] leading-[1.55] tracking-[-0.44px] font-inter">
          Book a short intro call with me and we can see if this is a fit.
        </p>
        <Button asChild variant="custom" className="mt-8">
          <a href="https://calendly.com/rarefolks/30mins" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[20px]">
            <img src="https://cdn.builder.io/api/v1/image/assets/7c9721f84f6b4184a42c3b93694252e5/4b29ad5ef4e1149b4e420e1c272132cec1a883ccf40583843dfe26bb61c5f198" alt="" className="w-6 h-6" />
            BOOK ON CALENDLY
          </a>
        </Button>
      </div>
    </section>;
};